<template>
  <div class="batchReceivableChange">
    <QS-scroller-box>
      <div>
        <QS-h3-title >
          <template slot="title">应收记录批量调整</template>
          <template slot="content">
            <el-tooltip class="item" content="车辆入库后，由系统创建的应收单操作变更，车辆交接时间将不可修改" placement="right"><i class="el-icon-question"></i></el-tooltip>
          </template>
        </QS-h3-title>
      </div>
      <div class="selectFile">
        <div class="selectFile_button">
          <span>选择文件：</span>
          <el-upload
            class="upload-demo"
            action=""
            :http-request="uploadRequest"
            :autoUpload="true"
            :file-list="fileList"
            :show-file-list="false"
          >
            <el-button type="primary" size="small">选择</el-button>
          </el-upload>
        </div>
        <el-button
          type="text"
          size="small"
          ><a :href="batchReceivableChange">导入模板下载</a></el-button
        >
      </div>
      <QS-common-table
        :data="batchReceivableList"
        :columns="headColumn"
        :pagination="paginationData"
        @change="paginationChange"
        class="mt16"
      ></QS-common-table>
      <!-- 增加输入框 -->
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px" style="margin-top: 20px">
        <el-form-item label="调整说明" prop="remark">
          <el-input :maxlength="500" style="width:300px" :rows="4" type="textarea" resize="none" v-model="formData.remark"></el-input>
        </el-form-item>
      </el-form>
      <template slot="bottomAction">
        <div class="sumbit-btns">
          <el-button @click="goPageBack" size="small">取消</el-button>
          <el-button
            v-if="!dingTalkShow"
            v-loading.fullscreen.lock="oLoading.submit"
            type="primary"
            size="small"
            :disabled="btnDisabled"
            @click="confirmBtn"
            >确认</el-button
          >
          <el-button
            v-else
            v-loading.fullscreen.lock="oLoading.submit"
            type="primary"
            size="small"
            :disabled="btnDisabled"
            @click="sunbmitDdApprove"
            >提交钉钉审批</el-button
          >
        </div>

      </template>
       <!-- 钉钉审批异常弹窗 -->
       <approve-validate-dialog
            ref="approveValidateDialogRef"
            :dingTalkShow="dingTalkShow"
            :sunbmitFun="batchChange"
            :tableData="batchReceivableList"
            @reloadClick="getDingTalkBtnStatus"
            :recordId="recordId"
        />
      <!-- 导入失败-弹窗 -->
      <dialogWrap
        v-model="uploadDialogShow"
        title="导入失败提示"
        :width="'750px'"

        class="spring-frame"
        :before-close="beforeUploadClose"
      >
        <p
          v-for="(item, index) in uploadTableData"
          :key="index"
          style="margin-bottom: 8px"
        >
          {{ item }}
        </p>
      </dialogWrap>

    </QS-scroller-box>
  </div>
</template>

<script>
import { interfacePrefix, batchReceivableChange } from '@/config'
import selectOption from '@/store/dict/selectOptionDict'
import axios from 'axios'
// eslint-disable-next-line import/no-cycle
import { getHead } from '@/utils'
import { setBatchReceivable, getBatchReceivableList, changeReceivableConfirm } from '@/api/financeApi'
import { mapState } from 'vuex'
import { getSubmitDingTalkShow } from '@/api/global'
import ApproveValidateDialog from './components/ApproveValidateDialog'

export default {
  components: {
    ApproveValidateDialog,
  },
  data() {
    return {
      batchReceivableChange,
      uploadDialogShow: false,
      uploadTableData: [],
      fileList: [],
      oLoading: {
        search: false,
        submit: false,
      },
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      batchReceivableList: [],
      headColumn: [
        {
          name: 'receiveId',
          columnProps: {
            label: '应收ID',
            prop: 'receiveId',
          },
        },
        {
          name: 'content',
          columnProps: {
            label: '收款内容',
            prop: 'content',
          },
          getText: ({ row }) => this.formatEnumeration(this.freeTypeList)[row.content],
        },
        {
          name: 'customerType',
          columnProps: {
            label: '付款方类型',
            prop: 'customerType',
          },
          getText: ({ row }) => selectOption.customerTypeDict[row.customerType],
        },
        {
          name: 'customer',
          columnProps: {
            label: '付款方',
            prop: 'customer',
            width: 160,
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            label: '车牌号',
            prop: 'plateNo',
            width: 100,
          },
        },
        {
          name: 'receivableDate',
          columnProps: {
            label: '应收日期',
            prop: 'receivableDate',
          },
        },
        {
          name: 'receivableAmount',
          columnProps: {
            label: '应收金额',
            prop: 'receivableAmount',
          },
        },
        {
          name: 'modifiedReceivableDate',
          columnProps: {
            label: '调整后应收日期',
            prop: 'modifiedReceivableDate',
          },
        },
        {
          name: 'modifiedReceivableAmount',
          columnProps: {
            label: '调整后应收金额',
            prop: 'modifiedReceivableAmount',
          },
        },

      ],
      recordId: '',
      formData: {
        remark: '',
      },
      rules: {
        remark: [
          { required: true, message: '请填写调整说明', trigger: 'blur' },
        ],
      },
      dingTalkShow: false, // 是否开启审批
    }
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
    btnDisabled() {
      return !(this.batchReceivableList && this.batchReceivableList.length)
    },
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
    // 钉钉审批是否启用
    this.getDingTalkBtnStatus()
  },
  methods: {
    // 确认按钮
    confirmBtn() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$refs.approveValidateDialogRef.receivableFilterReceivable()
        }
      })
    },
    // 提交钉钉审批
    sunbmitDdApprove() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          await this.getDingTalkBtnStatus()
          this.$refs.approveValidateDialogRef.sunbmitDdApprove()
        }
      })
    },
    // 查询钉钉审批是否开通
    async getDingTalkBtnStatus() {
      const params = {
        bizType: 11,
      }
      const { data } = await getSubmitDingTalkShow(params)
      this.dingTalkShow = data
    },
    // 提交数据
    batchChange(receivableIds) {
      if (this.oLoading.submit) return
      this.oLoading.submit = true
      changeReceivableConfirm({
        recordId: this.recordId,
        remark: this.formData.remark,
        approvalAccessModeType: this.dingTalkShow ? 2 : 1,
        receivableIds, // 正在审核中的数据
      }).then((res) => {
        const { code } = res
        if (code === 1) {
          const msg = this.dingTalkShow ? '发起审批成功' : '提交成功！'
          this.$message.success(msg)
          this.goPageBack(true)
        }
      }).finally(() => {
        this.oLoading.submit = false
      })
    },
    goPageBack(status = false) {
      this.$refreshBack(status)
    },
    // 获取表格数据
    getBatchReceivableList() {
      getBatchReceivableList({
        ...this.paginationData,
        recordId: this.recordId,
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.batchReceivableList = data.items
          this.paginationData.total = data.totalNum
        }
      })
    },
    // 分页
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.getBatchReceivableList()
    },
    beforeUploadClose() {
      this.uploadTableData = []
      this.uploadDialogShow = false
    },
    /* 自定义上传 */
    uploadRequest({ file }) {
      this.oLoading.search = true
      const formData = new FormData()
      formData.append('file', file)
      formData.append('group', 'finance')
      formData.append('code', 'finance_account_receive_record')
      axios({
        url: `${interfacePrefix}/fs/standard/upload`,
        method: 'POST',
        data: formData,
        headers: {
          ...this.headers,
          ...getHead(this.$store),
        },
        onUploadProgress: ({ loaded, total }) => {
          this.isProgress = true
          this.disabled = true
          this.uploadPercent = parseInt(loaded / total)
        },
      }).then(({ data: { code, data, msg } }) => {
        if (code === 1) {
          try {
            setBatchReceivable({
              fileAddress: data,
            })
              .then((res) => {
                // eslint-disable-next-line no-shadow
                const { code, data } = res
                if (code === 1 && data) {
                  const { msgList, recordId } = data
                  if (data && msgList.length > 0) {
                    this.uploadTableData = data.msgList || []
                    this.uploadDialogShow = true
                  } else {
                    this.recordId = recordId
                    // this.paginationChange(10, 1)
                    this.paginationChange({ pagination: { pageSize: 10, pageNum: 1 } })
                  }
                }
                this.oLoading.search = false
              })
              .catch(() => {
                this.oLoading.search = false
              })
          } catch (error) {
            this.oLoading.search = false
          }
        } else {
          // console.log(msg)
          this.fileList = []
          this.$message.error(msg)
        }
        this.oLoading.search = false
      }).catch(() => {
        this.fileList = []
        this.oLoading.search = false
      })
    },
  },
}
</script>

<style lang="less" scoped>
.batchReceivableChange{
  .selectFile {
    display: flex;
    align-items: center;
    .selectFile_button{
      display: flex;
      align-items: center;
      margin-right: 20px;
    }
  }
  .sumbit-btns {
    text-align: center;
  }
  .form-data{
    margin-top: 20px;
  }
}
</style>
